import { render, staticRenderFns } from "./FlyerDetail.vue?vue&type=template&id=4c1114ca&"
import script from "./FlyerDetail.vue?vue&type=script&lang=js&"
export * from "./FlyerDetail.vue?vue&type=script&lang=js&"
import style0 from "./FlyerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports